import React from 'react';
import { getApexInvestigationStatusColor } from 'Consts/Apex';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { useApexAdminPortalStateContext } from '../../../ApexAdminPortalContext';
import View from './View';

const Info = () => {
  const { investigationResource } = useApexAdminPortalStateContext();
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Investigation Details' });

  if (!investigationResource) {
    return null;
  }
  return (
    <View
      status={investigationResource.selectedOptionPrompt('status') || ''}
      statusColor={getApexInvestigationStatusColor(investigationResource.attr('status'))}
      jsonObject={investigationResource.attr('formTemplate')}
      amplitudeRootNodeProps={rootNodeProps}
      onClickAccordion={() => {
        logEvent('Click Account Info Accordion');
      }}
    />
  );
};

export default Info;
